import { render, staticRenderFns } from "./PageDetailRecipe.vue?vue&type=template&id=9b715ad4"
import script from "./PageDetailRecipe.vue?vue&type=script&lang=js"
export * from "./PageDetailRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports